import React from 'react';
import PropTypes from 'prop-types';
import Styles from './Headings.module.scss';

export const H1 = ({ children }) => {
  return <h1 className={Styles.h1}>{children}</h1>;
};

H1.propTypes = {
  children: PropTypes.any
};

export const H2 = ({ children }) => {
  return <h2 className={Styles.h2}>{children}</h2>;
};

H2.propTypes = {
  children: PropTypes.any
};

export const H5 = ({ children }) => {
  return <h5 className={Styles.h5}>{children}</h5>;
};

H5.propTypes = {
  children: PropTypes.any
};
